import {
    Flex,
    Grid,
    Heading,
    Image,
    Text,
    useColorMode,
} from "@chakra-ui/react";

import { getCurrentColor } from "../../constants";
import { Link } from "react-router-dom";
import mainPageBrandsSections from "../../data/mainPageBrandsSections";

const MainPageSectionBrands = ({ sections }) => {
    const { colorMode } = useColorMode();
    const blocks = sections || mainPageBrandsSections;

    return blocks.map((items) => {
        return (
            <Flex
                flexDirection={"column"}
                maxW={"1240px"}
                w={"100%"}
                key={items.title}
                mb={{ base: "50px", lg: "60px" }}
                mx={"auto"}
                px={{ base: "22px", ".5xl": "0px" }}
            >
                <Heading
                    mb={2}
                    fontFamily={"mainFont"}
                    fontSize={{ base: "25px", md: "3xl" }}
                    color={getCurrentColor(colorMode, "blackC.200", "whiteC.100")}
                >
                    {items.title}
                </Heading>
                <Text
                    mb={{ base: 6, md: "30px" }}
                    fontFamily={"mainFont"}
                    fontSize={"lg"}
                    color={getCurrentColor(colorMode, "grayC.100", "grayC.1600")}
                >
                    {items.description}
                </Text>
                <Grid
                    templateColumns={{
                        base: "repeat(2, 1fr)",
                        md: "repeat(3, 1fr)",
                        xl: "repeat(4, 1fr)",
                        ".5xl": "repeat(6, 1fr)",
                    }}
                    gap={"10px"}
                    mx={"auto"}
                >
                    {items.logos.map((logo, i) => (
                        <Flex
                            justifyContent={"center"}
                            key={i}
                            alignItems={"center"}
                            w={{ base: "150px", "1xs": "185px", lg: "198px" }}
                            h={{ base: "76px", lg: "82px" }}
                            borderRadius={"5px"}
                            border={"1px solid "}
                            borderColor={getCurrentColor(
                                colorMode,
                                "grayC.900",
                                "grayC.2400",
                            )}
                            boxShadow={
                                "0px 4px 14px 0px rgba(183, 183, 183, 0.02), 0px 20px 40px 0px rgba(183, 183, 183, 0.06)"
                            }
                            bg={getCurrentColor(colorMode, "whiteC.100", "transparent")}
                            padding="15px"
                        >
                            {logo.link ? (
                                <Link to={logo.link}>
                                    <Image
                                        objectFit={"scale-down"}
                                        w={"auto"}
                                        h={{ base: "70px", lg: "76px" }}
                                        loading="lazy"
                                        src={colorMode === "dark" ? logo.black : logo.white}
                                        alt={logo.white}
                                    />
                                </Link>
                            ) : (
                                <Image
                                    objectFit={"scale-down"}
                                    w={"auto"}
                                    h={{ base: "70px", lg: "76px" }}
                                    loading="lazy"
                                    src={colorMode === "dark" ? logo.black : logo.white}
                                    alt={logo.white}
                                />
                            )}
                        </Flex>
                    ))}
                </Grid>
            </Flex>
        );
    });
};

export default MainPageSectionBrands;
